import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ApiCallService } from 'src/app/api/service/api-call.service';
import { English, Kiswahili } from 'src/app/assets/strings/TZ/localization';
import { IConfirmDialogData } from 'src/app/components/dialog/dialog.data';
import { ValidationService } from 'src/app/services/validation.service';
import { environment } from 'src/environments/environment';
import * as Constants from 'src/app/constant/Constants';
import { ConfirmComponent } from 'src/app/components/dialog/confirm/confirm.component';

@Component({
  selector: 'app-buy',
  templateUrl: './buy.component.html',
  styleUrls: ['./buy.component.css']
})
export class BuyComponent implements OnInit {
  // Url Params
  insurance: string = "private"; // private, commercial, special, motorcycle ... etc.
  locale: string = "en";  // en || sw (Language)
  token: string = "placeholder-value"; // to validate the public access.
  // +++++++++++
  LanguagePack: any = English;
  pageHeading: string = 'Motor Insurance Application';
  genericDialogData: IConfirmDialogData = {
    title: '',
    content: '',
    cancelButtonText: '',
    confirmButtonText: ''
  };
  GenderOptions = [
    { value: 'M', view: this.LanguagePack.M},
    { value: 'F', view: this.LanguagePack.F},
    { value: 'O', view: this.LanguagePack.O}
  ]
  
  formErrors: { [key: string]: string } = {
    fullName: '',
    phone: '',
    email: '',
    dob: '',
    idNum: '',
    gender: '',
    region: '',
    district: '',
    postalAddress: '',
    coverStartDate: ''
  };
  formGroupErrors: { [key: string]: string } = {
    insuranceType: "",
  };
  validationMessages: { [key: string]: {[key: string]: string} } = {
    insuranceType: { required: this.LanguagePack.requiredValidation },
    fullName: { required: this.LanguagePack.requiredValidation },
    phone: { required: this.LanguagePack.requiredValidation },
    email: { required: this.LanguagePack.requiredValidation, email: this.LanguagePack.emailValidation },
    dob: { required: this.LanguagePack.requiredValidation },
    idNum: { required: this.LanguagePack.requiredValidation, minlength: this.LanguagePack.invalidNumValidation, maxlength: this.LanguagePack.invalidNumValidation},
    gender: { required: this.LanguagePack.requiredValidation },
    region: { required: this.LanguagePack.requiredValidation },
    district: { required: this.LanguagePack.requiredValidation },
    postalAddress: { required: this.LanguagePack.requiredValidation },
    coverStartDate: { required: this.LanguagePack.coverStartDateValidation }
  };

  kycForm = this._formBuilder.group({
    insuranceType: this._formBuilder.group({
      individual: true,
      corporate: false,
    }),
    fullName: ['', Validators.required],
    phone: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    dob: ['', Validators.required],
    idNum: ['', Validators.required],
    gender: ['', Validators.required],
    region: ['', Validators.required],
    district: ['', Validators.required],
    postalAddress: ['', Validators.required],
    coverStartDate: [moment(null), Validators.required]
  });

  loading: boolean = false;
  url: string = environment.baseUrl + Constants.thirdPartyBuyKYC_URL;
  selectedIdType: string = '';
  idNumPrefix: string = 'Enter ';
  idNumLabel: string = this.idNumPrefix.concat(this.LanguagePack.tinText);
  minIDNUMLength: number = 8;
  maxIDNUMLength: number = 9;

  // current date minus 18 years to ensure user is above 18 years
  maxDate: Date = new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate()); 
  // minDate should be maxDate minus 100 years to ensure user is below 100 years
  minDate: Date = new Date(this.maxDate.getFullYear() - 100, this.maxDate.getMonth(), this.maxDate.getDate());

  minCoverDate: Date = new Date();
  maxCoverDate: Date = new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate());

  constructor(
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private apiCallService: ApiCallService,
    private validationService: ValidationService
  ) { }

  ngOnInit(): void {
    this.validationService.subcribeToControlChanges(
      "insuranceType",
      this.kycForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.addOrRemoveValidationDependent(
      this.kycForm.get("insuranceType.individual")!,
      "dob",
      this.kycForm,
      this.formGroupErrors,
      this.validationMessages
    );
    this.validationService.addOrRemoveValidationDependent(
      this.kycForm.get("insuranceType.individual")!,
      "gender",
      this.kycForm,
      this.formGroupErrors,
      this.validationMessages
    );

    this.route.queryParams.subscribe((params) => {
      this.token = params["token"] !== 'undefined' ? params["token"] : Constants.tokenPlaceholderValue;
      
      if (params["locale"] !== undefined) {
        this.locale = params["locale"];
        // Change to Swahili language
        if (params["locale"] === "sw") {
          this.LanguagePack = Kiswahili;
          this.idNumPrefix = "Andika ";
          this.idNumLabel = this.idNumPrefix.concat(this.LanguagePack.tinText);

          this.validationMessages = {
            insuranceType: { required: this.LanguagePack.requiredValidation },
            fullName: { required: this.LanguagePack.requiredValidation },
            phone: { required: this.LanguagePack.requiredValidation },
            email: { required: this.LanguagePack.requiredValidation, email: this.LanguagePack.emailValidation },
            dob: { required: this.LanguagePack.requiredValidation },
            idNum: { required: this.LanguagePack.requiredValidation, minlength: this.LanguagePack.invalidNumValidation, maxlength: this.LanguagePack.invalidNumValidation},
            gender: { required: this.LanguagePack.requiredValidation },
            region: { required: this.LanguagePack.requiredValidation },
            district: { required: this.LanguagePack.requiredValidation },
            postalAddress: { required: this.LanguagePack.requiredValidation },
            coverStartDate: { required: this.LanguagePack.coverStartDateValidation }
          };
        }
      }

      if (params["insurance"] !== undefined) {
        this.insurance = params["insurance"];
        this.pageHeading = this.LanguagePack.pagePrivate;

        if (params["insurance"] === "commercial") {
          this.pageHeading = this.LanguagePack.pageCommercial;

        } else if (params["insurance"] === "special") {
          this.pageHeading = this.LanguagePack.pageSpecial;

        } else if (params["insurance"] === "motorcycle") {
          this.pageHeading = this.LanguagePack.pageMotorcycle;
        } else if (params["insurance"] === "psv") {
          this.pageHeading = this.LanguagePack.pagePSV;
        }
      }
    });

    this.kycForm.valueChanges.subscribe((form) => {
      this.logErrors();

      if (form.fullName) {
        this.kycForm.patchValue({
          fullName: form.fullName.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
      if (form.phone) {
        this.kycForm.patchValue({
          phone: form.phone.replace(/\D/g, '')
        }, {emitEvent: false});
      }
      if (form.idNum) {
        this.kycForm.patchValue({
          idNum: form.idNum.replace(/[a-z]/g, (match) => match.toUpperCase())
        }, {emitEvent: false});
      }
    });
  }

  logErrors() {
    this.formErrors = this.validationService.logValidationErrors(
      this.kycForm,
      this.formErrors,
      this.validationMessages
    );
  }

  showGenericPopup(runFunction: ()=> void) {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      disableClose: true,
      data: this.genericDialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      console.group('Generic Dialog');
      if (result) {
        console.log('dialog confirmed');
        runFunction();
      } else {
        console.log('dialog dismissed');
      }
      console.groupEnd();
    });
  };
  
  initDialogData(title: string, content: string, cancelButtonText: string, confirmButtonText: string) {
    this.genericDialogData.title = title;
    this.genericDialogData.content = content;
    this.genericDialogData.cancelButtonText = cancelButtonText;
    this.genericDialogData.confirmButtonText = confirmButtonText;
  };

  oninsuranceTypeIndividual() {
    this.kycForm.controls["insuranceType"].controls["corporate"].setValue(
      false
    );
  }

  oninsuranceTypeCorporate() {
    this.kycForm.controls["insuranceType"].controls["individual"].setValue(
      false
    );
    this.kycForm.controls["dob"].setValue('');
    this.kycForm.controls["gender"].setValue('');
  }

  postDataToWhatsapp = async () => {
    this.loading = true;

    const req = {
      class: this.insurance,
      insuranceType: this.kycForm.controls["insuranceType"].controls['individual'].value === true
        ? 1
        : 2,
      fullName: this.kycForm.controls["fullName"].value,
      phone: this.kycForm.controls["phone"].value,
      email: this.kycForm.controls["email"].value,
      dob: this.kycForm.controls["dob"].value,
      idNum: this.kycForm.controls["idNum"].value,
      gender: this.kycForm.controls["gender"].value,
      region: this.kycForm.controls["region"].value,
      district: this.kycForm.controls["district"].value,
      postalAddress: this.kycForm.controls["postalAddress"].value,
      coverStartDate: this.kycForm.controls["coverStartDate"].value!.format("MM-DD-YYYY"),
      token: this.token,
      filled: true,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);
      if (response.error === false) {
        // Auto-close the breakout page
        window.close();
      } else {
        console.error("::: Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          this.LanguagePack.submissionFailed,
          this.LanguagePack.savingError,
          this.LanguagePack.cancel,
          this.LanguagePack.tryAgain
        );

        this.showGenericPopup(this.postDataToWhatsapp);
      }
    } catch (error) {
      console.error('ERROR :: ', error);
      this.loading = false;

      this.initDialogData(
        this.LanguagePack.submissionFailed,
        this.LanguagePack.unexpectedError,
        this.LanguagePack.cancel,
        this.LanguagePack.tryAgain
      );
      this.showGenericPopup(this.postDataToWhatsapp);
    }  
  }

  submitForm(): void {
    this.initDialogData(
      this.LanguagePack.confirmSubmission,
      this.LanguagePack.proceedDesc,
      this.LanguagePack.back,
      this.LanguagePack.proceed
    );

    this.showGenericPopup(this.postDataToWhatsapp);
  }

  confirmCancel() {
    this.initDialogData(
      this.LanguagePack.warning,
      this.LanguagePack.confirmCancel,
      this.LanguagePack.backSmallCaps,
      this.LanguagePack.cancelApplication
    );

    this.showGenericPopup(this.cancelApplication);
  }
  
  cancelApplication = async () =>  {
    console.log("Cancelling application ...");
    // Update session that form application was cancelled
    this.loading = true;

    const req = {
      // User cancelled
      token: this.token,
      filled: false,
    };

    try {
      const response = await this.apiCallService.postRequest(`${this.url}?token=${this.token}`, req);

      console.log(":: Response data ::  ", response);

      if (response.error === false) {
        console.log("::: Cancel Post successful :::");
        // Auto-close the breakout page
        window.close();

      } else {
        console.error("::: Cancel Post failed :::", response.message);
        this.loading = false;

        this.initDialogData(
          this.LanguagePack.submissionFailed,
          this.LanguagePack.savingError,
          this.LanguagePack.cancel,
          this.LanguagePack.tryAgain
        );

        this.showGenericPopup(this.cancelApplication);
      }
    } catch (error) {
      console.error('cancelApplication :: ', error);
      this.loading = false;

      // Auto-close the breakout page
      window.close();
    }
  }

}
